/* eslint-disable */
/**
 * URL
 * @author David <david.prenninger@gmx.de>
 *
 * This file provides all helper functions related to URL manipulation and deserialization.
 */

export const serializeSectionObject = (sectionObjects, vue) => {
  const serializedSectionObjects = sectionObjects.map((section) => {
    return {
      s: section.stand ? section.stand.id : undefined,
      c1: section.clamp1 ? section.clamp1.id : undefined,
      co: section.connector ? section.connector.id : undefined,
      c2: section.clamp2 ? section.clamp2.id : undefined,
      g: section.glass ? section.glass.id : undefined,
    }
  });
  const q = {
    ...vue.$route.query,
    obj : window.btoa(JSON.stringify(serializedSectionObjects)),
  };
  vue.$router.push({ path: '/', query: q});
}

export const serializeDimensions = (dimensions, vue) => {
  const qs = vue.$route.query;
  const dimensionString =  window.btoa(JSON.stringify({s: dimensions}));
  if (qs.d !== dimensionString) {
    const q = {
      ...vue.$route.query,
      d : dimensionString,
    };
    vue.$router.push({ path: '/', query: q});
  }
};

export const serializeFinish = (finish, vue) => {
  const qs = vue.$route.query;
  if (Boolean(qs.f) !== finish) {
    const q = {
      ...vue.$route.query,
      f : finish,
    };
    vue.$router.push({ path: '/', query: q});
  }
}

export const serializeOffset = (offset, vue) => {
  const qs = vue.$route.query;
  const offsetString =  window.btoa(JSON.stringify(offset));
  if (qs.of !== offsetString) {
    const q = {
      ...vue.$route.query,
      of : offsetString,
    };
    vue.$router.push({ path: '/', query: q});
  }
};

export const resetURL = (vue) => {
  vue.$router.push({ path: '/', query: ''});
}

export const deserialize = (vue) => {
  const qs = vue.$route.query;
  let objectSections;
  let dimensions;
  let offset;
  let finished = false;

  const products = vue.$store.getters.products;

  if (qs.obj) {
    const objects = JSON.parse(window.atob(qs.obj));
    objectSections = objects.map((object, index) => {
      const outObject = {};
      if (object.s) {
        outObject.stand = products.find((product) => Number(product.id) === object.s);
      }
      if (object.c1) {
        outObject.clamp1 = products.find((product) => Number(product.id) === object.c1);
      }
      if (object.co) {
        if (index === 0) {
          outObject.connector = {
            ...products.find((product) => Number(product.id) === object.co),
            angle: 0,
            width: 0.1,
            length: 0.074,
            size: 11,
          };
        } else {
          outObject.connector = products.find((product) => Number(product.id) === object.co);
        }
      }
      if (object.c2) {
        outObject.clamp2 = products.find((product) => Number(product.id) === object.c2);
      }
      if (typeof object.g !== 'undefined') {
        outObject.glass = products.find((product) => {
          return Number(product.id) === object.g
        });
      }
      return outObject;
    });
  }

  if (qs.f) {
    finished = qs.f === 'true'

    if (
      objectSections
      && objectSections[objectSections.length - 1]
      && objectSections[objectSections.length - 1].stand
      && objectSections[objectSections.length - 1].connector
      && objectSections[objectSections.length - 1].connector.angle === 90
    ) {
      finished = true;
    }
  }

  if (qs.d) {
    dimensions = JSON.parse(window.atob(qs.d)).s;
  }

  if (qs.of) {
    offset = JSON.parse(window.atob(qs.of));
  }

  return {
    objectSections,
    dimensions,
    offset,
    finished,
  }
}


export const getUserDetails = (vue) => {
  const qs = vue.$route.query;

  const firstName = qs.fn;
  const lastName = qs.ln;
  const library = qs.li;
  const phone = qs.ph;
  const email = qs.em;
  const country = qs.cn;
  const region = qs.re;
  const zip = qs.zc;
  const salutation = qs.st;
  const street = qs.sn;
  const city = qs.ct;

  vue.$store.dispatch("setCustomerAgentData", {
    firstName,
    lastName,
    library,
    phone,
    email,
    country,
    region,
    zip,
    salutation,
    street,
    city,
  });

  delete vue.$route.query.fn;
  delete vue.$route.query.ln;
  delete vue.$route.query.li;
  delete vue.$route.query.ph;
  delete vue.$route.query.em;
  delete vue.$route.query.cn;
  delete vue.$route.query.re;
  delete vue.$route.query.zc;
  delete vue.$route.query.st;
  delete vue.$route.query.sn;

  vue.$router.replace({query:{
    ...vue.$route.query,
    ln: undefined,
  }});
}